var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('contacts',{attrs:{"data":_vm.getListContactByCompany.data,"pagination":_vm.getListContactByCompany.pagination,"fetch-callback":_vm.ListContactByCompany,"ids":{ company_id: _vm.$route.params.company_id }}})}
var staticRenderFns = []

export { render, staticRenderFns }